<template>
  <div>
    <h1>OK</h1>
  </div>
</template>

<script>
export default {
  name: "Health",
};
</script>